module.exports = __webpack_public_path__ + "static/media/Savings_Diagram_Desktop_EN.d0f9f561.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Savings_Diagram_Desktop_EN.png
// module id = 558
// module chunks = 0